export default function Warning() {
    return <div className='warning'>
        ⚠️ WARNING: this is a prototype. Please do not try to use this site on any non testnet blockchain
    </div>
}